import Jdataview from "jdataview";
import { MaskMetadata } from "./maskUtils";

const readMetadata = (png: Jdataview) => {
    const tExtId = 0x74455874;
    const iTxtId = 0x69545874;
    const zTxtId = 0x7a545874;

    try {
        const metaData: MaskMetadata = {};

        // Check for png file signature
        if (png.getUint32() !== 0x89504e47 || png.getUint32() !== 0x0d0a1a0a) {
            throw new Error("Invalid png file signature");
        }

        while (png.tell() < png.byteLength - 1) {
            // Get chunk header
            const chunkSize = png.getUint32();
            const chunkType = png.getUint32();

            // End of file?
            if (chunkType === 0x49454e44) break;

            // Valid chunk size?
            if (chunkSize === 0 || png.tell() + chunkSize > png.byteLength) {
                throw new Error("Invalid chunk size");
            }

            // Only look for the metadata text chunk
            if (chunkType === iTxtId || chunkType === tExtId || chunkType === zTxtId) {
                const pos = png.tell();

                // Find null byte separating key from value
                let keyLength = 0;
                for (keyLength = 0; keyLength < chunkSize && png.getUint8() !== 0x0; keyLength += 1) {
                    // The logic is done in the for itself
                }

                // Get key
                png.seek(pos);
                const key = png.getString(keyLength, undefined, "utf-8");
                png.seek(pos + keyLength + 1);

                // Get the beginning of the value (the first byte that is non-null)
                const valueLength = chunkSize - keyLength - 1;
                let startOffset = 0;
                while (startOffset < valueLength && png.getUint8() === 0x0) {
                    startOffset += 1;
                }

                // Get values (which also is a set of key value pairs)
                const data: { [key: string]: string } = {};
                if (startOffset < valueLength) {
                    png.seek(pos + keyLength + 1 + startOffset);
                    const value = png.getString(valueLength - startOffset, undefined, "utf-8");
                    const keyValuePairs = value.split(";");
                    for (let i = 0; i < keyValuePairs.length; i += 1) {
                        const pair = keyValuePairs[i];
                        if (pair !== "") {
                            const parts = pair.split("=");
                            data[parts[0]] = parts.length > 1 ? parts.slice(1).join("=") : parts[0];
                        }
                    }
                }
                metaData[key] = data;

                // Reset position
                png.seek(pos);
            }

            // Move to next chunk. The 4 extra bytes is CRC data for the chunk.
            png.seek(png.tell() + chunkSize + 4);
        }

        return metaData;
    } catch (e) {
        throw new Error(`PngMetaLoader.readMetadata: Error: ${e}`);
    }
};

const loadPngMetadata = async (pngFileUrl: string) => {
    const request = new Request(pngFileUrl, { mode: "cors" });

    const response = await fetch(request);
    const arrayBuffer = new Uint8Array(await response.arrayBuffer());

    return readMetadata(new Jdataview(arrayBuffer));
};

export default loadPngMetadata;
